import BaseApi from './baseApi';
export default class UploadServiceApi extends BaseApi {
    constructor(page: string) {
        super("FTP", page);
    }
  
    async UploadDocuments(formData : FormData) : Promise<string[]> {
        const response = await this.api.post('UploadFile', formData);
        if (!response) return [];
        if (response.isSuccess) {
            var urls: string[];
            urls = response.data as string[];
            return urls;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async DownloadDocuments(file: string, fileName: string) : Promise<void> {
        const response = await this.api.getRaw("DownloadFiles", { file: file }, { responseType: "arraybuffer" });
        // if (!response) return;
        
        if (!response) return;
        const blob = new Blob([response.data], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    }

    async DownloadPictures(file: string) : Promise<string> {
        const response = await this.api.getRaw("DownloadFiles", { file: file }, { responseType: "arraybuffer" });
        if (!response) return "";
        
        const blob = new Blob([response.data], { type: 'application/octet-stream' });
        const url = URL.createObjectURL(blob);
        return url;
    }
}
